// src/components/compliance/RtmUploadCard.jsx
// Thin wrapper — real implementation in shared/ui/FileDropzone.jsx.
import FileDropzone from "../../shared/ui/FileDropzone";
import { MAX_FILE_SIZE } from "../../utils/compliance/constants";

export default function RtmUploadCard({ onSubmit }) {
  return (
    <FileDropzone
      theme="legacy"
      accept={[".docx"]}
      maxTotalSize={MAX_FILE_SIZE}
      title="Upload requirements document"
      description={
        <>
          Accepted format: <strong>.docx</strong> only.
          The AI will analyse the requirements document and extract every requirement, traced back to its exact section, into a Requirements Traceability Matrix.
        </>
      }
      submitLabel="Generate Requirements Traceability Matrix"
      submittingLabel="Uploading…"
      onSubmit={onSubmit}
    />
  );
}
